import uhaulStore from "../../../CustomRedux/UhaulStore";
import ConversationTransferConfiguration from "./types/ServiceConfiguration";

const {
  enabled = false,
  coldTransfer = false,
  multiParticipant = false,
  showParticipantsTab = false
} = uhaulStore.getState().UhaulReducer.features.conversationTransfer as ConversationTransferConfiguration;

export const isFeatureEnabled = () => {
  return enabled;
};

export const isColdTransferEnabled = () => {
  return enabled && coldTransfer;
};

export const isMultiParticipantEnabled = () => {
  return enabled && multiParticipant;
};

export const isParticipantTabEnabled = () => {
  return enabled && showParticipantsTab;
};
